/**
 * The scale the find-the-best-weapon criterion measures candidates against.
 *
 * It is a property of the candidate pool — the best naked value in it — so it
 * depends on the character's level and on the metric, and the server computes it
 * (`gen/engine/weapon_pool.reference_dpa`) because the pool is a database read.
 * The kernel is handed it with the pool on every solve; this is the copy the
 * *display* needs, so the score the panel shows is the one the solver optimised
 * rather than a second answer derived some other way.
 *
 * Two numbers, matching the wire: `reference` is on the requested metric, and
 * `referenceDpa` is always damage per AP, which is what the efficiency factor
 * reads. Keyed by level *and* metric, because switching metric changes the
 * scale and the panel must not show one metric's term on the other's scale.
 *
 * Deliberately not persisted. Until a generation has authorised once, the
 * displayed score simply leaves this criterion out — which is visible and
 * harmless — where a locally re-derived reference would be invisible and wrong.
 */

const byKey = new Map();

const keyFor = (lvl, metric) => `${Number(lvl)}|${String(metric || '')}`;

export function rememberWeaponPoolReference(lvl, pool) {
    const reference = Number(pool?.reference);
    const referenceDpa = Number(pool?.reference_dpa);
    if (!Number.isFinite(Number(lvl)) || !Number.isFinite(reference) || reference <= 0) return;
    byKey.set(keyFor(lvl, pool?.metric), {
        reference,
        referenceDpa: Number.isFinite(referenceDpa) ? referenceDpa : reference,
    });
}

/** `{reference, referenceDpa}` for this level and metric, or null if unfetched. */
export function weaponPoolReference(lvl, metric) {
    return byKey.get(keyFor(lvl, metric)) ?? null;
}
